import { combineReducers } from "redux";
import createReducer from "utils/createReducer";

import * as create from "./create";

export default combineReducers({
  create: createReducer(create),
});
